<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="registration-title">
            Participant Information
        </div>
        <div class="account_section_box">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.AccountNpiNumber">
                        <label>NPI Number
                            <span v-if="!Account.UseLicenseNumber">*</span>
                            <span v-bind:data-balloon="npiTooltip" data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa fa-question-circle-o"></i>
                            </span>
                        </label>
                        <input type="text" maxlength="10" v-model="Account.NpiNumber" v-on:paste="pasteNpiNumber($event)" v-bind:class="{ error_field: AccountValidationResult.AccountNpiNumber }" class="form-control" v-on:keyup="ValidateNpiNumber(Account.NpiNumber)" v-on:keypress="G_NumberCheck(this.event)">
                        <p class="error-message" v-if="AccountValidationResult.AccountNpiNumber">{{AccountValidationResult.AccountNpiNumber}}</p>
                        <p class="error-message" v-if="invalidNpiNumberPaste">Sorry, only numeric NPI values can be pasted here.</p>
                        <!-- <p>{{called}}</p> -->
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.AccountNpiNumber">
                        <label>Relationship*
                            <span v-bind:data-balloon="relationshipTooltip" data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa fa-question-circle-o"></i>
                            </span>
                        </label>
                        <select v-bind:class="{ error_field: AccountValidationResult.Role }" v-bind:disabled="FormInputs.IndividualOrganization"  v-model="Account.Role" class="form-control" style="height:36.5px;">
                            <!-- <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option> -->
                            <option>Self</option>
                            <option>Employee</option>
                            <option>Contractor</option>
                            <option>Unaffiliated</option>
                            <option>Other</option>
                        </select>
                        <!-- <input type="text" maxlength="10" v-model="Account.Relationship" v-bind:class="{ error_field: AccountValidationResult.Relationship }" class="form-control"> -->
                        <p class="error-message" v-if="AccountValidationResult.Role">{{AccountValidationResult.Role}}</p>
                    </div>
                </div>
                <div v-if="Account.UseLicenseNumber == false || Account.UseLicenseNumber == null" class="clearfix"></div>
                <div v-if="Account.UseLicenseNumber == true" class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label>License Number*</label>
                        <input maxlength="18" v-bind:class="{ error_field: AccountValidationResult.AccountLicenseNumber }" v-model="Account.LicenseNumber" type="text" class="form-control">
                        <p class="error-message" v-if="AccountValidationResult.AccountLicenseNumber">{{AccountValidationResult.AccountLicenseNumber}}</p>
                    </div>
                </div>
                <div v-if="Account.UseLicenseNumber == true" class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label>State*</label>
                        <select v-bind:class="{ error_field: AccountValidationResult.AccountState }"  v-model="Account.State" class="form-control" style="height:36.5px;">
                            <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option>
                        </select>
                        <p class="error-message" v-if="AccountValidationResult.AccountState">{{AccountValidationResult.AccountState}}</p>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="form-check" v-show="FormInputs.AccountHasNpiNumber">
                        <input v-on:click="Account.UseLicenseNumber = !Account.UseLicenseNumber" type="checkbox" class="form-check-input">
                        <label>I don't have an NPI number</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.ContactFirstName">
                        <label v-if="FormInputs.IndividualLabels">Participant First Name*</label>
                        <label v-else>Primary Contact First Name*</label>
                        <input v-bind:class="{ error_field: ContactValidationResult.ContactFirstName }" v-model="FirstName" type="text" class="form-control capitalize">
                        <p class="error-message" v-if="ContactValidationResult.ContactFirstName">{{ContactValidationResult.ContactFirstName}}</p>
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.ContactLastName">
                        <label v-if="FormInputs.IndividualLabels">Participant Last Name*</label>
                        <label v-else>Primary Contact Last Name*</label>
                        <input v-bind:class="{ error_field: ContactValidationResult.ContactLastName }" v-model="LastName" type="text" class="form-control capitalize">
                        <p class="error-message" v-if="ContactValidationResult.ContactLastName">{{ContactValidationResult.ContactLastName}}</p>
                    </div>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.ContactSuffix">
                        <label>Suffix*</label>
                        <select v-bind:class="{ error_field: ContactValidationResult.ContactSuffix }" v-model="passSuffix" class="form-control" style="height: 36.5px;">
                            <option v-for="(value, key) in Suffix" v-bind:value="key">{{key}}</option>
                        </select>
                        <p class="error-message" v-if="ContactValidationResult.ContactSuffix">{{ContactValidationResult.ContactSuffix}}</p>
                    </div>
                </div>
            </div>

            <!--Started enhancement-->
            <div class="row">
                <div class="col-lg-6 col-md-9 col-sm-9 col-xs-12">
                    <label v-if="FormInputs.IndividualLabels">
                        Participant Phone Number*
                    </label>
                    <label v-else>
                        Primary Contact Phone Number*
                    </label>
                    <div class="row div-phone">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 sm">
                            <input ref="participant_number_1" type="text" maxlength="3" v-on:keypress="NumberCheck(this.event)" v-on:keyup="NextField(1)" v-bind:class="{ error_field: ContactValidationResult.ContactPhoneNumber }" v-model="Account.PrimaryContact.CountryCode" class="form-control">
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 sm">
                            <input ref="participant_number_2" type="text" maxlength="3" v-on:keypress="NumberCheck(this.event)" v-on:keyup="NextField(2)" v-bind:class="{ error_field: ContactValidationResult.ContactPhoneNumber }" v-model="Account.PrimaryContact.AreaCode" class="form-control">
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 md">
                            <input ref="participant_number_3" type="text" maxlength="4" v-on:keypress="NumberCheck(this.event)" v-on:keyup="NextField(3)" v-bind:class="{ error_field: ContactValidationResult.ContactPhoneNumber }" v-model="Account.PrimaryContact.Phone" class="form-control">
                        </div>
                    </div>
                    <p class="error-message" v-if="ContactValidationResult.ContactPhoneNumber">{{ContactValidationResult.ContactPhoneNumber}}</p>
                </div>

                <div class="col-lg-6 col-md-9 col-sm-9 col-xs-12">
                    <div class="form-group" v-show="FormInputs.ContactRole">
                        <label v-if="FormInputs.BusinessLabels">Role in Business</label>
                        <label v-else>Role in Organization</label>
                        <select v-model="Account.PrimaryContact.Title" class="form-control" style="height: 36.5px;">
                            <option v-for="(value, key) in (FormInputs.RoleBusiness ? RoleBusiness : RoleNonProfit)" v-bind:value="value">{{key}}</option>
                        </select>
                    </div>
                </div>

                <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12" v-show="FormInputs.ContactYearsInPractice">
                    <label>Year Licensed</label>
                    <input v-bind:class="{ error_field: ContactValidationResult.ContactYearsInPractice }" v-model="Account.PrimaryContact.YearsInPractice" type="text" maxlength="4" class="form-control" v-on:keypress="G_NumberCheck(this.event);" v-on:keyup="G_NumberOfYearsCheck(Account.PrimaryContact, 'YearsInPractice')" v-on:blur="CheckYearLicense()">
                    <p class="error-message" v-if="ContactValidationResult.ContactYearsInPractice">{{ContactValidationResult.ContactYearsInPractice}}</p>
                    <p v-if="errorMessage.year && !ContactValidationResult.ContactYearsInPractice" class="error-message">{{errorMessage.year}}</p>
                </div>

                <div class="col-lg-6 col-md-9 col-sm-9 col-xs-12">
                    <div class="form-check primarycontact-eyedoctor" v-show="FormInputs.BusinessPrimaryContact">
                        <input type="checkbox" v-model="Account.PrimaryContact.IsEyeDoctor" v-on:change="MakeParticipantDoctor()" class="form-check-input">
                        <label class="form-check-label" v-if="FormInputs.BusinessLabels">Primary Contact is an Eye Doctor</label>
                        <label class="form-check-label" v-if="FormInputs.NonProfitLabels">Primary Contact is an Eye Doctor</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-lg-5 col-md-5 col-sm-12 col-xs-12" v-show="FormInputs.ParticipantAccountNpiNumber">
                    <div class="form-group" v-show="FormInputs.ParticipantAccountNpiNumber">
                        <label v-if="FormInputs.BusinessLabels">Business NPI Number
                            <span v-bind:data-balloon="npiForBusinessTooltip" data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa fa-question-circle-o"></i>
                            </span>
                        </label>
                        <input v-if="FormInputs.BusinessLabels" type="text" maxlength="10" v-model="Account.BusinessNpiNumber" v-on:paste="pasteNpiNumber($event)" v-bind:class="{ error_field: AccountValidationResult.AccountBusinessNpiNumber }" class="form-control" v-on:keyup="ValidateNpiNumberForBusinessType()" v-on:keypress="G_NumberCheck(this.event)">
                        <p class="error-message" v-if="AccountValidationResult.AccountBusinessNpiNumber">{{AccountValidationResult.AccountBusinessNpiNumber}}</p>
                        <p class="error-message" v-if="invalidNpiNumberPaste">Sorry, only numeric NPI values can be pasted here.</p>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.ContactLegalName">
                        <label v-if="FormInputs.BusinessLabels">Legal Business Name* (Practice)</label>
                        <label v-if="FormInputs.NonProfitLabels">Legal Organization Name* (Participant)</label>
                        <input v-bind:class="{ error_field: ContactValidationResult.ContactLegalName }" v-model="Account.PrimaryContact.LegalName" type="text" class="form-control">
                        <p class="error-message" v-if="ContactValidationResult.ContactLegalName">{{ContactValidationResult.ContactLegalName}}</p>
                    </div>
                </div>
            </div>

            <!--end-->

            <!--added Individual NPI Number enhancement-->

            <div class="row" name="Account.PrimaryContact.IsEyeDoctor">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.IndividualNpiNumber  && Account.PrimaryContact.IsEyeDoctor">
                        <div class="row">
                            <div class="col-lg-5 col-md-9 col-sm-9 col-xs-12">
                              <label>Individual NPI Number
                            <span v-if="!Account.IsPrimaryLicenseNumber">*</span>
                            <span v-bind:data-balloon="npiTooltip" data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa fa-question-circle-o"></i>
                            </span>
                        </label>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div>
                                            <input type="text" maxlength="10" v-model="Account.PrimaryContact.NpiNumber" v-bind:class="{ error_field: ContactValidationResult.ContactNpiNumber }" class="form-control" v-on:keyup="ValidateNpiNumber(Account.PrimaryContact.NpiNumber)" v-on:keypress="G_NumberCheck(this.event)">
                                            <p class="error-message" v-if="ContactValidationResult.ContactNpiNumber">{{ContactValidationResult.ContactNpiNumber}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                                            <div class="col-lg-5 col-md-9 col-sm-9 col-xs-12">
                                              <div class="form-group">
                                                <label>Relationship*
                                                    <span v-bind:data-balloon="relationshipTooltip" data-balloon-pos="down" data-balloon-length="large">
                                                        <i class="fa fa-question-circle-o"></i>
                                                    </span>
                                                </label>
                                                <select v-bind:class="{ error_field: ContactValidationResult.Role }"  v-model="Account.Role" @change="AccountRoleChanged(Account.Role)" class="form-control" style="height:36.5px;">
                                                    <!-- <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option> -->
                                                    <option>Self</option>
                                                    <option>Employee</option>
                                                    <option>Contractor</option>
                                                    <option>Unaffiliated</option>
                                                    <option>Other</option>
                                                </select>
                                                <!-- <input type="text" maxlength="10" v-model="Account.Relationship" v-bind:class="{ error_field: AccountValidationResult.AccountRelationship }" class="form-control"> -->
                                                <p class="error-message" v-if="ContactValidationResult.Role">{{ContactValidationResult.Role}}</p>
                                              </div>
                                            </div>

                            <!--<div class="col-lg-5 col-md-9 col-sm-9 col-xs-12">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label>Affiliation with Account
                            <span>*</span>
                            <span v-bind:data-balloon="doctorAffiliationToolTip" data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa fa-question-circle-o"></i>
                            </span>
                        </label>
                                        <div>
<div class="form-group" >
                        <select v-model="Account.PrimaryContact.Affiliation" class="form-control">
                            <option>Self</option>
                            <option>Employee (Part Time)</option>
                            <option>Employee (Full Time)</option>
                            <option>Contractor</option>
                            <option>Unaffiliated</option>
                            <option>Volunteer</option>
                            <option>Other</option>
                        </select>
                    </div>                                            <p class="error-message" v-if="ContactValidationResult.ContactNpiNumber">{{ContactValidationResult.ContactNpiNumber}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>-->

                        </div>
                            <div class="col-lg-6 col-md-9 col-sm-9 col-xs-12">
                                <div class="form-check" v-show="FormInputs.BusinessPrimaryContact">
                                    <input type="checkbox" v-model="Account.PrimaryContact.IsPrimaryLicenseNumber" v-on:change="updateUseLicenseNumber();  Account.IsPrimaryLicenseNumber = !Account.IsPrimaryLicenseNumber" class="form-check-input">
                                    <label class="form-check-label">Use License Number</label>
                                </div>
                            </div>                    </div>
                </div>
            </div>
            <!--Individual NPI Number end-->

            <!--added License Number-->

            <div class="row">
                <div class="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 " v-show="FormInputs.IndividualNpiNumber  && Account.PrimaryContact.IsPrimaryLicenseNumber">
                    <div class="row">
                        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label>License Number*</label>
                                <input maxlength="18" v-bind:class="{ error_field: ContactValidationResult.ContactLicenseNumber }" v-model="primaryLicenseNumber" type="text" class="form-control">
                                <p class="error-message" v-if="ContactValidationResult.ContactLicenseNumber">{{ContactValidationResult.ContactLicenseNumber}}</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label>State*</label>
                                <select v-bind:class="{ error_field: ContactValidationResult.ContactState }" v-model="primaryState" class="form-control" style="height:36.5px;">
                                    <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option>
                                </select>
                                <p class="error-message" v-if="ContactValidationResult.ContactState">{{ContactValidationResult.ContactState}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--added license Number end-->



            <!-- <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.ContactBusinessType">
                        <label v-if="FormInputs.IndividualLabels || FormInputs.BusinessLabels">Business Type
                            <span v-bind:data-balloon="businessTypeTooltip" data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa fa-question-circle-o"></i>
                            </span>
                        </label>
                        <label v-else>Organization Type
                            <span v-bind:data-balloon="organizationTypeTooltip" data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa fa-question-circle-o"></i>
                            </span>
                        </label>
                        <select v-model="Account.PrimaryContact.BusinessType" v-bind:disabled="FormInputs.IndividualOrganization || FormInputs.BusinessOrganization" class="form-control" style="height: 36.5px;">
                            <option v-for="(value, key) in (FormInputs.BusinessTypeIndividual ? BusinessTypeIndividual : (FormInputs.BusinessTypeBusiness ? BusinessTypeBusiness : BusinessTypeNonProfit))" v-bind:value="value">{{key}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                    <div class="form-check" v-show="FormInputs.ContactIsMultiLocation">
                        <input type="checkbox" v-model="Account.PrimaryContact.IsMultiLocation"  v-bind:disabled="FormInputs.BusinessOrganization || FormInputs.NonProfitOrganization" class="form-check-input">
                        <label class="form-check-label" v-if="FormInputs.BusinessLabels">Are you a Multi-Location Business?</label>
                        <label class="form-check-label" v-else>Are you a Multi-Location Organization?</label>
                    </div>
                </div>
            </div> -->
        </div>
        <loading-component v-if="isLoading"></loading-component>
    </div>
</template>
<script>
  import LoadingComponent from "@/components/shared/LoadingComponent";
// import { ModelSelect } from 'vue-search-select';
export default {
  props: [
    "Account",
    "AccountValidationResult",
    "FormInputs",
    "ContactValidationResult",
    "Suffix",
    "RoleNonProfit",
    "RoleBusiness",
    "BusinessTypeNonProfit",
    "BusinessTypeBusiness",
    "BusinessTypeIndividual",
    "State",
  ],
  components: {LoadingComponent},
  data() {
    return {
      yearStarted: [],
      yearToday: new Date().getFullYear(),
      errorMessage: {
        year: null
      },
      FirstName: null,
      LastName: null,
      passSuffix: null,
      NpiNumber: null,
      primaryLicenseNumber: null,
      primaryState: null,
      isLoading: false,
      invalidNpiNumberPaste: false,
    };
  },
  computed: {
    GetNpi() {
      return this.Account.PrimaryContact.NpiNumber;
    },
    GetLicenseNumber() {
      return this.Account.PrimaryContact.IsPrimaryLicenseNumber;
    },
    GetAccountValidationResult() {
      return this.AccountValidationResult;
    },
    GetContactValidationResult() {
      return this.ContactValidationResult;
    },
    GetPrimaryContact() {
      return this.Account.PrimaryContact;
    },
  },
  watch: {
    'Account.PrimaryContact.Phone'(newValue) {
     this.$set(this.Account.PrimaryContact.OfficeLocation, 'Phone', newValue);
  },
  'Account.PrimaryContact.CountryCode'(newValue) {
    this.$set(this.Account.PrimaryContact.OfficeLocation, 'CountryCode', newValue);
  },
  'Account.PrimaryContact.AreaCode'(newValue) {
    this.$set(this.Account.PrimaryContact.OfficeLocation, 'AreaCode', newValue);
  },
    GetNpi(val) {
      if (this.Account.PrimaryContact.IsEyeDoctor) {
        this.Account.EyeDoctors[0].NpiNumber = val;
        this.Account.NpiNumber = val;
      }
      if (val && val.length === 10) {
        // do nothing
      }
      else {
        this.NpiNumber
        this.FirstName = null;
        this.LastName = null;
        this.passSuffix = null;
        this.Account.PrimaryContact.CountryCode = null;
        this.Account.PrimaryContact.AreaCode = null;
        this.Account.PrimaryContact.Phone = null;
        this.Account.EyeDoctors[0].NpiNumber = val;
        this.Account.NpiNumber = null;
      }
    },
    GetLicenseNumber(val) {
      if (this.Account.PrimaryContact.IsEyeDoctor) {
        this.Account.EyeDoctors[0].UseLicenseNumber = val;
      }
      if (val && val.length === 10) {
        // do nothing
      }
      else {
        this.primaryLicenseNumber = null;
        this.primaryState = null;
      }
    },
    FirstName: function(val) {
      if (val) {
        this.Account.PrimaryContact.FirstName = val;
        if (this.Account.PrimaryContact.IsEyeDoctor) {
          this.Account.EyeDoctors[0].FirstName = this.Account.PrimaryContact.FirstName;
        }
      } else {
        this.Account.EyeDoctors[0].FirstName = "";
      }
    },
    LastName: function(val) {
      if (val) {
        this.Account.PrimaryContact.LastName = val;
        if (this.Account.PrimaryContact.IsEyeDoctor) {
          this.Account.EyeDoctors[0].LastName = this.Account.PrimaryContact.LastName;
        }
      } else {
        this.Account.EyeDoctors[0].LastName = "";
      }
    },
    passSuffix: function(val) {
      if (val) {
        this.Account.PrimaryContact.Suffix = val;
        if (this.Account.PrimaryContact.IsEyeDoctor) {
          this.Account.EyeDoctors[0].Suffix = this.Account.PrimaryContact.Suffix;
        }
      } else {
        this.Account.EyeDoctors[0].Suffix = "";
      }
    },
    primaryLicenseNumber: function(val) {
      if (val) {
        this.Account.PrimaryContact.LicenseNumber = val;
        this.Account.LicenseNumber = val;
        if (this.Account.PrimaryContact.IsPrimaryLicenseNumber) {
          this.Account.EyeDoctors[0].LicenseNumber = this.Account.PrimaryContact.LicenseNumber;
        }
      } else {
        this.Account.EyeDoctors[0].LicenseNumber = '';
        // this.Account.PrimaryContact.LicenseNumber = '';
        this.Account.LicenseNumber = '';
      }
    },
    primaryState: function(val) {
      if (val) {
        this.Account.PrimaryContact.State = val;
        this.Account.State = val;
        if (this.Account.PrimaryContact.IsPrimaryLicenseNumber) {
          this.Account.EyeDoctors[0].State = this.Account.PrimaryContact.State;
        }
      }
    }
  },
  methods: {
    AccountRoleChanged(role){
        this.Account.EyeDoctors[0].Role = role;
    },
    pasteNpiNumber(event) {
      var re = /^\d+$/;
      if (!re.test(event.clipboardData.getData('text'))) {
        this.invalidNpiNumberPaste = true;
      } else {
        this.invalidNpiNumberPaste = false;
      }
    },
    MakeParticipantDoctor() {
      if (this.Account.PrimaryContact.IsEyeDoctor == false) {
        this.Account.NpiNumber = null;
        this.Account.EyeDoctors[0].NpiNumber = null;
        this.Account.EyeDoctors[0].FirstName = null;
        this.Account.EyeDoctors[0].LastName = null;
        this.Account.EyeDoctors[0].Suffix = null;
        this.Account.EyeDoctors[0].LicenseNumber = null;
        this.Account.EyeDoctors[0].State = null;
        this.Account.PrimaryContact.IsPrimaryLicenseNumber = false;
        this.Account.EyeDoctors[0].UseLicenseNumber = false;
        this.Account.PrimaryContact.NpiNumber = null;
        this.FirstName = null;
        this.LastName = null;
        this.passSuffix = null;
        this.Account.PrimaryContact.CountryCode = null;
        this.Account.PrimaryContact.AreaCode = null;
        this.Account.PrimaryContact.Phone = null;
        this.Account.Role = null;
      }
      else {
        this.Account.EyeDoctors[0].FirstName = this.FirstName;
        this.Account.EyeDoctors[0].LastName = this.LastName;
        this.Account.EyeDoctors[0].Suffix = this.passSuffix;
      }
      // if (this.Account.PrimaryContact.IsEyeDoctor == false) {
      //   this.Account.EyeDoctors[0].FirstName = this.Account.PrimaryContact.FirstName;
      //   this.Account.EyeDoctors[0].LastName = this.Account.PrimaryContact.LastName;
      //   this.Account.EyeDoctors[0].Suffix = this.Account.PrimaryContact.Suffix;
      //   this.Account.EyeDoctors[0].NpiNumber = this.Account.NpiNumber;
      // }
      // if (this.Account.PrimaryContact.IsEyeDoctor) {
      //   this.FirstName = "";
      //   this.LastName = "";
      //   this.passSuffix = "";
      //   this.Account.EyeDoctors[0].FirstName = null;
      //   this.Account.EyeDoctors[0].LastName = null;
      //   this.Account.EyeDoctors[0].Suffix = null;
      //   this.Account.EyeDoctors[0].NpiNumber = null;
      //   this.Account.PrimaryContact.FirstName = null;
      //   this.Account.PrimaryContact.LastName = null;
      //   this.Account.PrimaryContact.Suffix = null;
      //   this.Account.NpiNumber = null;
      //   this.Account.PrimaryContact.CountryCode = null;
      //   this.Account.PrimaryContact.AreaCode = null;
      //   this.Account.PrimaryContact.Phone = null;
      //   this.Account.PrimaryContact.NpiNumber = null;
      // }
    },
    PassNpiValue() {
      if (this.Account.NpiNumber) {
        this.FirstName = this.Account.PrimaryContact.FirstName;
        this.LastName = this.Account.PrimaryContact.LastName;
        this.passSuffix = this.Account.PrimaryContact.Suffix;
        //   (this.primaryLicenseNumber = this.Account.EyeDoctors.LicenseNumber) &&
        //   (this.primaryState = this.Account.PrimaryContact.State);
      }
    },
    updateUseLicenseNumber() {
      if (this.Account.PrimaryContact.IsPrimaryLicenseNumber) {
        this.Account.EyeDoctors[0].LicenseNumber = this.primaryLicenseNumber;
        this.Account.EyeDoctors[0].State = this.primaryState;
      }
      else {

        this.Account.EyeDoctors[0].LicenseNumber = null;
        this.Account.EyeDoctors[0].State = null;
      }
      // if (this.Account.PrimaryContact.IsPrimaryLicenseNumber) {
      //   this.Account.EyeDoctors[0].LicenseNumber = this.Account.PrimaryContact.LicenseNumber;
      //   this.Account.EyeDoctors[0].State = this.Account.PrimaryContact.State;
      //   this.Account.PrimaryContact.IsEyeDoctorsLicenseNumber = false;
      //   this.Account.EyeDoctors[0].UseLicenseNumber = false;
      // }
      // if (this.Account.PrimaryContact.IsPrimaryLicenseNumber == false) {
      //   this.primaryLicenseNumber = "";
      //   this.primaryState = "";
      //   this.Account.EyeDoctors[0].LicenseNumber = null;
      //   this.Account.EyeDoctors[0].State = null;
      //
      //   this.Account.PrimaryContact.LicenseNumber = null;
      //   this.Account.PrimaryContact.State = null;
      //   this.Account.PrimaryContact.IsEyeDoctorsLicenseNumber = true;
      //   this.Account.EyeDoctors[0].UseLicenseNumber = true;
      // }
    },
    NumberCheck(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
      // else {
      //this.FocusNextField(this.$refs.participant_number_1, this.$refs.participant_number_2, this.$refs.participant_number_3);
      // return true;
      // }
    },
    ValidateNpiNumber(npi) {
      // this.$emit("npiIsDirty");
      var _this     = this;
      // var npiNumber = _this.Account.PrimaryContact.NpiNumber;
      var npiNumber = npi;
      if(npiNumber.length == 10){
        _this.isLoading = true;

        var doctor =
          {
            AccountType: this.$route.params.type,
            NpiNumber: npiNumber
          };

        axios.post('/Account/IsNpiNumberValid/', doctor)
          .then(response => {
            if(response.data.isSuccess)
            {
              // _this.NewDoctorValidationResult = {EyeDoctorNpiNumber: null};

              var details      = response.data.raw.results[0];
              var basicDetails = details.basic;
              var address      = details.addresses[0];

              _this.FirstName = _this.ConvertToTitleCase(basicDetails.first_name);
              _this.LastName  = _this.ConvertToTitleCase(basicDetails.last_name);
              _this.passSuffix    = basicDetails.credential;
              _this.Account.PrimaryContact.CountryCode = address.telephone_number.split(
                "-"
              )[0];
              _this.Account.PrimaryContact.AreaCode = address.telephone_number.split(
                "-"
              )[1];
              _this.Account.PrimaryContact.Phone = address.telephone_number.split(
                "-"
              )[2];

              _this.isLoading = false;
              _this.GetContactValidationResult.ContactNpiNumber = '';
              _this.GetAccountValidationResult.AccountNpiNumber = '';
            }
            else
            {
              // _this.NewDoctorValidationResult = {EyeDoctorNpiNumber: response.data.errorMessage};
              _this.GetContactValidationResult.ContactNpiNumber = response.data.errorMessage;
              _this.GetAccountValidationResult.AccountNpiNumber = response.data.errorMessage;
              _this.FirstName = null;
              _this.LastName  = null;
              _this.passSuffix    = null;
              _this.Account.PrimaryContact.CountryCode = null;
              _this.Account.PrimaryContact.AreaCode = null;
              _this.Account.PrimaryContact.Phone = null;

              _this.isLoading = false;
            }
          })
          .catch(error => {
            console.log(error);
          });
      }


    },
    ValidateNpiNumberForBusinessType() {
      // this.$emit("npiForBusiness");
      var _this = this;
      var npiNumber = _this.Account.BusinessNpiNumber;
      if (npiNumber.length == 10) {
        _this.isLoading = true;
        var business = {
          AccountType: this.$route.params.type,
          BusinessNpiNumber: npiNumber,
        }

        axios
          .post("/Account/IsNpiNumberBusinessType", business)
          .then(response => {
            if (response.data.isSuccess) {
              _this.GetAccountValidationResult.AccountNpiNumber = null;
              var details = response.data.raw.results[0];
              var basicDetails = details.basic;
              var address = details.addresses[0];

              var legalName = this.ConvertToTitleCase(basicDetails.organization_name);
              _this.GetPrimaryContact.LegalName = legalName;
              _this.isLoading = false;

              _this.GetAccountValidationResult.AccountBusinessNpiNumber = '';

            } else {

              _this.GetAccountValidationResult.AccountBusinessNpiNumber = response.data.errorMessage;

              _this.called = _this.GetAccountValidationResult.AccountBusinessNpiNumber;
              _this.GetPrimaryContact.LegalName = null;
              _this.isLoading = false;
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    NextField(field) {
      var focus1 = this.$refs.participant_number_1;
      var focus2 = this.$refs.participant_number_2;
      var focus3 = this.$refs.participant_number_3;

      if (field == 1 && focus1.value.length == 3) {
        focus2.focus();
      } else if (field == 2 && focus2.value.length == 3) {
        focus3.focus();
      }
    },
    FocusNextField(element1, element2, element3) {
      // To proceed in next field when matched the required number of digits
      if (element1.value.length == 2) {
        element2.focus();
      } else if (element2.value.length == 2) {
        element3.focus();
      }
    },
    NumberOfYearsCheck(yearsInpractice) {
      if (yearsInpractice < 1) yearsInpractice = null;
      else yearsInpractice = input;
    },
    ComputeYear() {
      var year = this.yearToday;
      for (var i = 0; i < 30; i++) {
        this.yearStarted.push({ value: year, text: year });
        year += 1;
      }
    },
    CheckYearLicense() {
      var year = this.Account.PrimaryContact.YearsInPractice;
      var result = this.G_CheckYearLicense(year);
      if (result) this.errorMessage.year = result;
      else this.errorMessage.year = "";
    }
  },
  created() {
    this.ComputeYear();
    console.log(this.FormInputs);
    if(this.FormInputs.IndividualOrganization) this.Account.Role = 'Self'
    if(this.Account.PrimaryContact.FirstName) this.FirstName = this.Account.PrimaryContact.FirstName;
    if(this.Account.PrimaryContact.LastName) this.LastName = this.Account.PrimaryContact.LastName;
    if(this.Account.PrimaryContact.Suffix) this.passSuffix = this.Account.PrimaryContact.Suffix;
  }
};
</script>



// WEBPACK FOOTER //
// ParticipantInformation.vue?2ac829e1